import { DateTime } from 'luxon'

import { FilterComparison, FilterLogic } from './enums'
import { Filter, FilterField, FilterGroup, FilterParam } from './types'

import { generateRandomKey } from '@/helpers/common'

const isActiveParam = (param: FilterParam, fields?: FilterField[]) => {
  const { comparison, field, value } = param
  const fieldSettings = fields?.find(item => item.name === field)
  return (
    (!fieldSettings?.isDate && !!value) ||
    (
      fieldSettings?.isDate &&
      (
        comparison === FilterComparison.LAST ||
        DateTime.fromISO(`${value}`).isValid
      )
    ) ||
    (comparison &&
      [FilterComparison.EMPTY, FilterComparison.NOTEMPTY].includes(comparison))
  )
}

const isActiveGroup = (group: FilterGroup) => !!group.params.length

export const getActiveFilters = (storage: Filter, fields?: FilterField[], excludeKey?: string) => {
  const groups = storage?.params
    ?.map(param => {
      const params = param.params
        .filter(param =>
          (excludeKey === undefined || param.key !== excludeKey) &&
          isActiveParam(param, fields)
        )
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .map(({ key, ...item }) => item)
      return {
        params,
        logic: param.logic,
      }
    })
    .filter(isActiveGroup)
  const logic = storage?.logic
  return groups?.length
    ? ({
      params: groups,
      logic,
    } as Filter)
    : undefined
}

export const normalizeOldData = (data: any) => {
  if (!data) return
  if (!Array.isArray(data.params)) {
    return {
      logic: data.logic,
      params: [
        {
          key: generateRandomKey(),
          logic: data.logic,
          params: [
            {
              ...data.params,
              key: generateRandomKey(),
            },
          ],
        },
      ],
    }
  } else if (data.params?.[0]?.field) {
    return {
      logic: data.logic,
      params: (data.params as any[]).map(param => ({
        key: generateRandomKey(),
        logic: data.logic,
        params: [
          {
            ...param,
            key: generateRandomKey(),
          },
        ],
      })),
    }
  } else {
    return data
  }
}

export const formatFilterParams = (value?: Filter) => {
  const params = value?.params.reduce((acc, item) => {
    return [...acc, ...item.params?.map(item => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { key, ...rest } = item
      return rest
    }) || []]
  }, [] as FilterParam[])
  if (!params?.length) return
  return {
    logic: value?.logic || FilterLogic.AND,
    params,
  } as FilterGroup
}
